//flod_limit_list
export const FLOD_LIMIT_LIST = [
    {value: 1, name: "Buy in 16 Stakes 1/2"},
    {value: 2, name: "Buy in 32 Stakes 2/4"},
    {value: 3, name: "Buy in 80 Stakes 5/10"},
    {value: 4, name: "Buy in 160 Stakes 10/20"},
    {value: 5, name: "Buy in 400 Stakes 25/50"},
    {value: 6, name: "Buy in 800 Stakes 50/100"},
    {value: 7, name: "Buy in 1600 Stakes 100/200"},
]

//holdem_limit_list
export const HOLDEM_LIMIT_LIST = [
    {value: 1, name: "Buy in 100 - 400 Stakes 1/2"},
    {value: 2, name: "Buy in 200 - 800 Stakes 2/4"},
    {value: 3, name: "Buy in 500 - 2,000 Stakes 5/10"},
    {value: 4, name: "Buy in 1,000 - 4,000 Stakes 10/20"},
    {value: 5, name: "Buy in 2,500 - 10,000 Stakes 25/50"},
    {value: 6, name: "Buy in 5,000 - 2,0000 Stakes 50/100"},
    {value: 7, name: "Buy in 10,000 - 40,000 Stakes 100/200"},
]

//sixplus_holdemlimit_list
export const SIXPLUS_HOLDEMLIMIT_LIST = [
    {value: 1, name: "Buy in 50 - 200 Ante 1"},
    {value: 2, name: "Buy in 100 - 400 Ante 2"},
    {value: 3, name: "Buy in 200 - 800 Ante 4"},
    {value: 4, name: "Buy in 250 - 1,000 Ante 5"},
    {value: 5, name: "Buy in 500 - 2,000 Ante 10"},
    {value: 6, name: "Buy in 1,000 - 4,000 Ante 20"},
    {value: 7, name: "Buy in 2,500 - 10,000 Ante 50"},
    {value: 8, name: "Buy in 5,000 - 20,000 Ante 100"},
]

//plo4_limit_list
export const PLO4_LIMIT_LIST = [
    {value: 1, name: "Buy in 100 - 400 Stakes 1/2"},
    {value: 2, name: "Buy in 200 - 800 Stakes 2/4"},
    {value: 3, name: "Buy in 500 - 2,000 Stakes 5/10"},
    {value: 4, name: "Buy in 1,000 - 4,000 Stakes 10/20"},
    {value: 5, name: "Buy in 2,500 - 10,000 Stakes 25/50"},
    {value: 6, name: "Buy in 5,000 - 2,0000 Stakes 50/100"},
    {value: 7, name: "Buy in 10,000 - 40,000 Stakes 100/200"}
]

//plo5_limit_list
export const PLO5_LIMIT_LIST = [
    {value: 1, name: "Buy in 100 - 400 Stakes 1/2"},
    {value: 2, name: "Buy in 200 - 800 Stakes 2/4"},
    {value: 3, name: "Buy in 500 - 2,000 Stakes 5/10"},
    {value: 4, name: "Buy in 1,000 - 4,000 Stakes 10/20"},
    {value: 5, name: "Buy in 2,500 - 10,000 Stakes 25/50"},
    {value: 6, name: "Buy in 5,000 - 2,0000 Stakes 50/100"},
    {value: 7, name: "Buy in 10,000 - 40,000 Stakes 100/200"}
]